import styled from '@emotion/styled';

import { Box } from '@mui/material';

import creditCard from '../../../../assets/creditCard.svg';
import { getColor } from '../../../common/UICommon';

export const CardFormWrapper = styled(Box)`
  font-weight: 600;
  line-height: 20px;
  color: ${getColor('BLACK')};
  margin-bottom: 32px;
`;

export const Date = styled(Box)`
  display: flex;
  margin-top: 12px;
  & div {
    flex-grow: 1;
  }
`;

export const CardDiv = styled.div<{ error?: boolean }>`
  border-radius: 4px;
  padding-top: 16px;
  background-color: ${getColor('WHITE')};
  height: 48px;
  &.creditCard {
    background-image: url(${creditCard});
    background-repeat: no-repeat;
    background-position: 12px 10px;
    padding-left: 50px;
  }
  &.other {
    padding-left: 16px;
  }

  ${({ error }) => error && `border: 1px solid ${getColor('RED_100')};`};
`;

export const CardIfo = styled.div`
  width: 50%;
  &.exp {
    margin-right: 16px;
  }
`;

export const PaymentButtonContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: ${getColor('BLACK')};
  border-radius: 4px;
`;

export const ExpressCheckoutContainer = styled(Box)`
  margin-bottom: 32px;
  max-width: 528px;
  flex-direction: row;
  padding: 0px;
  margin: 0px;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${getColor('GRAY_30')};
`;
export const PaymentButtonWrapper = styled(Box)`
  width: 100%;
`;
